/**
 * External store for live dimension preview during slider drags.
 * Bypasses Redux so undo history is not polluted with intermediate values.
 * GhostModel reads from here via useSyncExternalStore.
 */

export interface PreviewDimensions {
  width: number
  height: number
  depth: number
  cornerRadius: number
  edgeBevel: number
}

let snapshot: PreviewDimensions | null = null
const listeners = new Set<() => void>()

const notify = () => listeners.forEach((l) => l())

export const setPreviewDimensions = (dims: PreviewDimensions) => {
  snapshot = dims
  notify()
}

export const clearPreviewDimensions = () => {
  snapshot = null
  notify()
}

export const getPreviewSnapshot = (): PreviewDimensions | null => snapshot

export const subscribePreview = (listener: () => void): (() => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
